var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "max-width": "520",
        scrollable: "",
        "content-class": "dialog-panoramica-mobile-info",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "panoramica-mobile-info-card" },
        [
          _c(
            "v-img",
            {
              staticClass: "panoramica-mobile-info-image",
              attrs: {
                "aspect-ratio": "1.7777778",
                src: _vm.promoPanoramicaImage,
              },
            },
            [
              _c(
                "div",
                { staticClass: "panoramica-mobile-info-title-overlay" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "panoramica-mobile-info-title font-hemi-head",
                    },
                    [_vm._v("\n          Visuale Panoramica\n        ")]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "panoramica-mobile-info-content white--text pa-4" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "mt-3 mb-4",
                  attrs: { dense: "", text: "", color: "secondary" },
                },
                [
                  _vm._v(
                    "\n        Disponibile solo da tablet o desktop.\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "panoramica-mobile-info-browser" }, [
                _c(
                  "div",
                  { staticClass: "font-weight-bold font-italic mb-1" },
                  [_vm._v('"Come possa fare ora?"')]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mb-2" }, [
                  _vm._v(
                    "\n          Copia questo link su uno schermo più grande e potrai attivare la visuale 'Panoramica'.\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "panoramica-mobile-info-link secondary--text",
                    attrs: { href: _vm.urlAsta, target: "_blank" },
                  },
                  [_vm._v("\n          " + _vm._s(_vm.urlAsta) + "\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-center mt-3" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { color: "secondary", rounded: "" },
                        on: { click: _vm.copyUrl },
                      },
                      [
                        _c("v-icon", { attrs: { left: "", small: "" } }, [
                          _vm._v("content_copy"),
                        ]),
                        _vm._v("\n            Copia link\n          "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.copyFeedback
                  ? _c(
                      "div",
                      { staticClass: "panoramica-mobile-info-feedback" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.copyFeedback) +
                            "\n        "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            { staticClass: "justify-center pb-4" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "font-hemi-head px-8",
                  attrs: { color: "secondary", outlined: "", rounded: "" },
                  on: { click: _vm.dismiss },
                },
                [_vm._v("\n        Ho capito\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }